module.exports = __webpack_public_path__ + "static/img/ket-renewal-tablet-sub-05.61bcf58.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/ket-renewal/ket-renewal-tablet-sub-05.png
// module id = bFMk
// module chunks = 0